import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

const DEFAULT_INTERVAL = 10000; // 10 secs of inaccuracy is acceptable

const useClock = (updateInterval = DEFAULT_INTERVAL) => {
  const [time, setTime] = useState(moment());

  useEffect(() => {
    const interval = setInterval(() => setTime(moment()), updateInterval);

    return () => clearInterval(interval);
  });

  return time;
};

const Clock = ({ format }) => {
  const time = useClock();

  return time.format(format);
};

Clock.defaultProps = {
  format: 'LT[M]',
};

Clock.propTypes = {
  format: PropTypes.string,
};

export default Clock;
